module.exports = __webpack_public_path__ + "img/DE02182.e2fe974b.png";